<script setup lang="ts">
/* UTILS */
/* AF-LIB */
import { ALButton, useCssBreakpoints } from '@af-lib/vue-ui';
import { computed } from 'vue';

/* STORE */
import { useOverlayStore } from '@/components/drawers/overlayStore';
/* COMPONENTS */
import Text from '@/components/text/Text.vue';
/* ENUMS */
import { CONGRATS_MODAL_NAME } from '@/enums/overlaysName';
/* TYPES */
import type { CongratsModalParams } from '@/types/overlays/overlays.types';

const { isMobile } = useCssBreakpoints();

const overlayStore = useOverlayStore();

defineEmits(['update:modelValue']);

const dialogParams = computed(() => {
  return overlayStore.getOverlayParams(CONGRATS_MODAL_NAME) as CongratsModalParams;
});

const isDialogOpen = computed({
  get: () => {
    return overlayStore.overlays[CONGRATS_MODAL_NAME]?.open || false;
  },
  set: value => {
    const overlay = overlayStore.overlays[CONGRATS_MODAL_NAME];
    if (overlay) {
      overlay.open = value;
    }
  }
});
</script>
<template>
  <v-dialog
    v-model="isDialogOpen"
    :width="isMobile ? '100%' : '600px'"
    :contentClass="isMobile ? 'congratsModalMobile ma-0' : ''"
  >
    <div
      :style="`width: ${isMobile ? '100%' : '600px'}; height: 380px; position: relative; border-radius: 6px`"
      class="d-flex align-center justify-center overflow-hidden shadow"
    >
      <div class="whiteBg bg-white"></div>
      <div class="conicGradient"></div>
      <v-card
        class="d-flex flex-column align-center justify-center text-center bg-transparent"
        width="calc(100% - 10px)"
        height="calc(100% - 10px)"
      >
        <v-sheet width="100%" height="120px" color="bg-white d-flex align-center justify-center" style="opacity: 0.8">
          <v-icon :icon="dialogParams.icon || 'fat fa-party-horn'" class="text-icon-1" />
        </v-sheet>
        <v-sheet width="100%" class="px-10 bg-white grow d-flex flex-column align-center justify-space-around">
          <Text type="h3">{{ dialogParams.title }}</Text>
          <Text v-for="text in dialogParams.texts" :key="text" type="body3">{{ text }}</Text>
        </v-sheet>
        <v-sheet width="100%" height="70px" color="bg-white d-flex align-center justify-space-around">
          <ALButton type="tertiary" :label="$t('general.close')" @click="isDialogOpen = false" />
        </v-sheet>
      </v-card>
    </div>
  </v-dialog>
</template>

<style scoped>
.wobble {
  animation: wobble 0.5s ease 0.5s 1 normal forwards;
}
.whiteBg {
  width: 800px;
  height: 800px;
  border-radius: 100%;

  position: absolute;
}

.conicGradient {
  width: 800px;
  height: 800px;
  border-radius: 100%;

  position: absolute;
  animation: spin 5s linear infinite;

  background: conic-gradient(
    rgba(var(--v-theme-decor-variant-5), 0.45),
    rgba(var(--v-theme-decor-variant-3), 0.45),
    rgba(var(--v-theme-decor-variant-5), 0.45),
    rgba(var(--v-theme-decor-variant-3), 0.45),
    rgba(var(--v-theme-decor-variant-5), 0.45)
  );
}
@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.shadow {
  box-shadow:
    0px 4px 5px 0px rgba(var(--v-theme-shadowColor), 0.14),
    0px 1px 10px 0px rgba(var(--v-theme-shadowColor), 0.12),
    0px 4px 4px 0px rgba(var(--v-theme-shadowColor), 0.25);
}

@keyframes wobble {
  0%,
  100% {
    transform: translateX(0%);
    transform-origin: 50% 50%;
  }

  15% {
    transform: translateX(-30px) rotate(6deg);
  }

  30% {
    transform: translateX(15px) rotate(-6deg);
  }

  45% {
    transform: translateX(-15px) rotate(3.6deg);
  }

  60% {
    transform: translateX(9px) rotate(-2.4deg);
  }

  75% {
    transform: translateX(-6px) rotate(1.2deg);
  }
}
</style>
